import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const services = () => import('../views/service')

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '/',
      component: HomePage
    },
    {
      path: '/service',
      name: 'service',
      component: services
    }
  ]
});

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
      return VueRouterPush.call(this, to).catch(err => err)
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js